package app

import app.dashboard.Dashboard
import app.emails.Emails
import app.login.Login
import app.properties.Credit
import react.*
import react.router.dom.*

class App : RComponent<RProps, RState>() {
    override fun RBuilder.render() {
        browserRouter {
            switch {
                route("/", exact = true) {
                    creditForm(Credit())
                }
                route("/admin", Login::class)
                route("/emails", Emails::class)
                route("/creditType", CreditTypeCrud::class)
                route("/region", RegionCrud::class)
                route("/guaranty", GuarantyCrud::class)
                route("/currency", CurrencyCrud::class)
                route("/dashboard", Dashboard::class)
                route("/user", UserCrud::class)
            }
        }
    }
}

fun RBuilder.app() = child(App::class) {}
